import cloneDeep from 'lodash/cloneDeep';
import { STATUS_ORDER, STATUS_ORDER_LIST } from '../utils/constant';

export class OrderAction {
  constructor(
    action,
    createdAt,
    estimatedAt,
    title,
    meta,
  ) {
    this.action = action;
    this.createdAt = createdAt;
    this.estimatedAt = estimatedAt;
    this.title = title;
    this.meta = meta;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new OrderAction(
        input.action,
        input.created_at,
        input.estimated_at,
        input.title,
        MetaTracking.fromApiArray(input)
      )
    }

    return new OrderAction();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => OrderAction.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [OrderAction.fromApiObject(input)];
    }

    return [];
  }

  static getCurrentStatus(statusList = []) {
    if (!statusList.length) {
      return {};
    }
    let result = {};
    let indexCur;
    let list = cloneDeep(statusList).reverse();

    for (let index = 0; index < list.length; index++) {
      const item = list[index];
      if (item.createdAt && !result.action) {
        let element = STATUS_ORDER_LIST.find(i => i.id === item.action);
        if (element) {
          indexCur = statusList.findIndex(i => i.action === item.action);
          result = item;
          break;
        }
      }
    }

    return {
      indexCur: indexCur || 0,
      action: STATUS_ORDER.CREATE,
      ...result
    };
  }
}

export class MetaTracking {
  constructor(
    statusText,
    createdAt,
    cancelReason
  ) {
    this.statusText = statusText;
    this.createdAt = createdAt;
    this.cancelReason = cancelReason;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new MetaTracking(
        input.status_text,
        input.created_at,
        input.cancel_reason
      )
    }

    return new MetaTracking();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => MetaTracking.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [MetaTracking.fromApiObject(input)];
    }

    return [];
  }
}